import React from 'react';

function TathataLogo() {
  /* eslint-disable max-len */
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="99.425%" x2="50%" y2="-6.113%" id="a">
          <stop stopColor="#8C1436" offset="0%" />
          <stop stopColor="#8C1436" stopOpacity=".99" offset="1%" />
          <stop stopColor="#881B34" stopOpacity=".46" offset="49%" />
          <stop stopColor="#851F33" stopOpacity=".13" offset="83%" />
          <stop stopColor="#842132" stopOpacity="0" offset="100%" />
        </linearGradient>
      </defs>
      <g transform="translate(0 2)" fill="none">
        <ellipse fill="#FFF" opacity=".5" cx="7.505" cy="7.009" rx="7.505" ry="7.009" />
        <path
          d="M7.505.125C3.432.125.125 3.215.125 7.01s3.307 6.884 7.373 6.884c4.065 0 7.372-3.09 7.372-6.885 0-3.798-3.3-6.887-7.365-6.887z"
          fill="#B1132F"
        />
        <ellipse fill="url(#a)" style={{ mixBlendMode: 'multiply' }} cx="7.505" cy="7.009" rx="7.094" ry="6.628" />
        <path
          d="M18.428 5.894l1.246-1.247h-3.99v-.734H13.63v.74H8.614v-.74h-2.05v.74H2.57l1.25 1.25h2.743v.512h-2.57L5.25 7.62h1.315v8.31l2.047-.353V7.62h5.026v7.957l2.047.36V7.62H17l1.254-1.248h-2.57v-.478h2.744zm-9.816 0h1.872v.513H8.612v-.513zm5.026.513h-1.866v-.513h1.86l.006.513z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
  /* eslint-enable */
}

export default TathataLogo;



// WEBPACK FOOTER //
// ./src/common/icons/Tathata-Logo.js